import React, { memo } from 'react';
import { Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import styles from './styles.module.css';
import './styles.css';

/**
 * 警告モーダルの実装
 */
interface WarningModalProps {
    title?: React.ReactNode | null;
    body?: React.ReactNode | null;
    txtSubmit?: string | null;
    isOpen: boolean;
    onSubmit?: () => void;
    onCancel?: () => void;
}

const WarningModal = memo(({ title, body, txtSubmit, isOpen, onSubmit, onCancel }: WarningModalProps) => {
    /**
     * onSubmitを実行してモーダルを閉じる
     */
    const onSubmitModal = () => {
        try {
            if (typeof onSubmit !== 'function') throw new Error('onSubmit is not function');
            onSubmit();
        } catch {}
    };

    /**
     * モーダルを閉じる
     */
    const onCloseModal = () => {
        try {
            if (typeof onCancel !== 'function') throw new Error('onCancel is not function');
            onCancel();
        } catch {}
    };

    return (
        <Modal
            className={'warning-modal'}
            destroyOnHidden
            maskClosable={false}
            closable={false}
            title={title}
            width={280}
            open={isOpen}
            centered
            onCancel={() => onCloseModal()}
            footer={null}
        >
            <WarningOutlined className={styles.icon} />
            <div className={styles.textContainer}>{body}</div>
            <div className={styles.warningModalFooter}>
                <button key="submit" type="submit" onClick={() => onSubmitModal()}>
                    {txtSubmit}
                </button>
            </div>
        </Modal>
    );
});

export default WarningModal;
